import { render, staticRenderFns } from "./jiaofei.vue?vue&type=template&id=a98adc46&scoped=true"
import script from "./jiaofei.vue?vue&type=script&lang=js"
export * from "./jiaofei.vue?vue&type=script&lang=js"
import style0 from "./jiaofei.vue?vue&type=style&index=0&id=a98adc46&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98adc46",
  null
  
)

export default component.exports